import { Component, Input, OnChanges } from '@angular/core';
import { Channel } from 'icreate/common/models/channel';
import { ElementSettings, ToggleStatus } from 'icreate/common/models/editor-viewer-element';

@Component({
    selector: 'app-toggle-interactions',
    templateUrl: './toggle-interactions.component.html',
    styleUrls: ['./toggle-interactions.component.css'],
    standalone: false,
})
export class ToggleInteractionsComponent implements OnChanges {
    @Input() assignedChannel: Channel;
    @Input() element: SVGElement;
    @Input() elementSettings: ElementSettings;

    toggleState: ToggleStatus;

    activeStatus: string;
    inactiveStatus: string;

    statusOptions: string[];

    showingActiveOptions: boolean = false;
    showingInactiveOptions: boolean = false;
    previewStates: boolean = false;

    ngOnChanges(): void {
        this.toggleState = this.elementSettings?.toggleState;
        if (this.assignedChannel) {
            this.statusOptions = [
                this.assignedChannel.fcuData.digitalAlarmSetting.statusStringContactOn,
                this.assignedChannel.fcuData.digitalAlarmSetting.statusStringContactOff,
            ];
        }
        const contactOn = this.assignedChannel.fcuData.digitalAlarmSetting.statusStringContactOn;
        const contactOff = this.assignedChannel.fcuData.digitalAlarmSetting.statusStringContactOff;
        if (this.toggleState) {
            this.activeStatus = this.toggleState.active === 1 ? contactOn : contactOff;
            this.inactiveStatus = this.toggleState.inactive === 1 ? contactOn : contactOff;
        }
    }

    updatePreviewStates(event) {
        this.previewStates = event.checked;

        const toggleEvent = new CustomEvent('updateToggleState', {
            detail: { checked: this.previewStates },
        });
        this.element.dispatchEvent(toggleEvent);
    }

    updateSettings() {
        this.elementSettings.toggleState = this.currentToggleState ?? null;
    }

    get currentToggleState(): ToggleStatus {
        if (!this.activeStatus || !this.inactiveStatus) return null;
        else {
            const contactOn = this.assignedChannel.fcuData.digitalAlarmSetting.statusStringContactOn;
            return {
                active: this.activeStatus === contactOn ? 1 : 0,
                inactive: this.inactiveStatus === contactOn ? 1 : 0,
            };
        }
    }

    get hasSettingError(): boolean {
        if (!this.activeStatus || !this.inactiveStatus) return true;
        return false;
    }
}
